import { IoClose } from "react-icons/io5";
import { Modal as ModalProps } from "./index.types";
import "./index.css";
import Button from "../button";
import clsx from "clsx";

export function Modal({
  className,
  modalref,
  children,
  title,
  subtitle,
  footer,
  hasOverlay = true,
  hasCloseButton = true,
  handleClose,
  ...rest
}: ModalProps) {
  return (
    <>
      {hasOverlay && <div className="modal-overlay" />}
      <div ref={modalref} className={clsx("modal", className)} {...rest}>
        {hasCloseButton && (
          <Button
            mode="secondary"
            className="modal__close"
            size="small"
            onClick={handleClose}
          >
            <IoClose />
          </Button>
        )}
        <div className="modal__content">
          {title && (
            <div className="modal__header">
              <h3>{title}</h3>
              <h6>{subtitle}</h6>
            </div>
          )}
          <div className="modal__children">{children}</div>
          {footer && <div className="modal__footer">{footer}</div>}
        </div>
      </div>
    </>
  );
}

export default Modal;
